import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from "../Banner";
import SubNav from "../SubNav";
import Footer from "../../Footer";

const easyofuse = require("../../../assets/icons-pack/3.4 Elastic Kubernetes Services/ic_01_easyofuse.svg");
const highperformance = require("../../../assets/icons-pack/3.4 Elastic Kubernetes Services/ic_02_highperformance.svg");
const highavailible = require("../../../assets/icons-pack/3.4 Elastic Kubernetes Services/ic_03_highavailible.svg");
const open = require("../../../assets/icons-pack/3.4 Elastic Kubernetes Services/ic_04_open.svg");

const KCS = () => {
    const heading = `KUBERNETES CLUSTER SERVICE (KCS)`;
    const details = `A high-performance, high-reliability service for enterprises to manage containerized applications. `;

    const overview = [
        `DETASAD Kubernetes Cluster Service is a high-performance, high-reliability service through which enterprises can manage containerized applications.  Kubernetes Cluster Service supports native Kubernetes applications and tools, allowing you to easily set up a container runtime environment on the cloud.`
    ];

    const advantages = [
        [
            `Ease of Use `,
            `Automatic creation of Kubernetes clusters; one-click rolling update; one-stop deployment and O&M of containerized applications. `,
            easyofuse
        ],
        [
            `High Performance `,
            `Kubernetes network built from extensive field experience; auto scaling within seconds; huge performance advantage of bare metal containers over virtual machine containers. `,
            highperformance
        ],
        [
            `High Availability `,
            `High availability on the cluster control plane and across AZs; graceful scale-out and scale-in of containerized applications ensure high service continuity. `,
            highavailible
        ],
        [
            `Open`,
            `Support for native Kubernetes and Docker versions; among the first CNCF-certified Kubernetes service providers; top contributor to the Kubernetes and Docker communities. `,
            open
        ]
    ];

    const functions = [
        [
            `Deployment and O&M `,
            [
                `One-click creation of Kubernetes clusters; auto deployment, auto O&M, and lifecycle management of containerized apps. `
            ]
        ],
        [
            `High Availability `,
            [
                `High Availability on the cluster control plane and across Availability Zones. Graceful scale-out and scale-in of containerized apps.`
            ]
        ],
        [`DevOps`, [`Capability of building images from Java, Python, Go, Node.js, and Vert.x code.`]]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
}

export default KCS;
